module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Import Courses',
      "size": 'lg',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "px-7 flex-grow overflow-y-auto overflow-x-hidden"
  }, [(_vm.courses.length) ? _c('div', {
    staticClass: "my-5 flex items-center"
  }, [_c('img', {
    staticClass: "w-10 h-10 rounded-full",
    attrs: {
      "src": ("/static/integrations/" + (_vm.integration.provider_name) + ".png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-base font-semibold text-gray-700 ml-3"
  }, [_vm._v("\n        " + _vm._s(_vm.integration.provider_name) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.courses.length) ? _c('div', {
    staticClass: "mb-2.5 text-sm text-gray-500"
  }, [_vm._v("\n      You can create and roster new courses in Parlay from this window. If you\n      want to connect an existing Parlay course to a\n      " + _vm._s(_vm.integration.provider_name) + " course, you can do this through the\n      \"Course Settings\" tab inside of that course.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loadingCourses) ? _c('div', {
    staticClass: "flex items-center justify-center w-full mt-10"
  }, [_c('pl-spinner', {
    staticClass: "x2"
  })], 1) : _c('div', {
    class: _vm.courses.length ?
      'inline-block bg-white rounded-md border w-full text-sm' :
      'h-full'
  }, [(_vm.courses.length) ? _c('table', {
    staticClass: "w-full h-full"
  }, [_c('thead', [_c('th', {
    staticClass: "w-1/12 font-normal border-b text-left p-3 cursor-pointer"
  }, [_c('pl-checkbox', {
    on: {
      "change": function($event) {
        return _vm.handleSelectAll($event)
      }
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "w-4/12 font-normal border-b text-left p-3 cursor-pointer"
  }, [_vm._v("\n            Title\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "w-2/12 font-normal border-b text-left p-3 cursor-pointer hidden md:table-cell"
  }, [_vm._v("\n            Subject\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "w-2/12 font-normal border-b text-left p-3 cursor-pointer hidden md:table-cell"
  }, [_vm._v("\n            Grade\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "w-2/12 font-normal border-b text-left p-3 cursor-pointer hidden md:table-cell"
  }, [_vm._v("\n            School Site\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "w-1/12 font-normal border-b text-left p-3 cursor-pointer"
  }, [_vm._v("\n            Existing Parlay Course ?\n          ")])]), _vm._v(" "), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "course-list"
    }
  }, _vm._l((_vm.courses), function(course, index) {
    return _c('tr', {
      key: course.id,
      staticClass: "border-b transition-all duration-300"
    }, [_c('td', {
      staticClass: "w-1/12 p-3"
    }, [_c('pl-checkbox', {
      on: {
        "change": function($event) {
          return _vm.handleSelectCourse($event, index)
        }
      },
      model: {
        value: (_vm.selectedCourses[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedCourses, index, $$v)
        },
        expression: "selectedCourses[index]"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "w-4/12 p-3 truncate"
    }, [_vm._v("\n              " + _vm._s(course.name) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "w-2/12 p-3 truncate hidden md:table-cell"
    }, [(course.subjects && course.subjects.length) ? _c('div', _vm._l((course.subjects), function(subject, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate",
        attrs: {
          "title": subject
        }
      }, [_vm._v("\n                  " + _vm._s(subject) + "\n                ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "w-2/12 p-3 truncate hidden md:table-cell"
    }, [(course.grades && course.grades.length) ? _c('div', _vm._l((course.grades), function(grade, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate",
        attrs: {
          "title": grade
        }
      }, [_vm._v("\n                  " + _vm._s(grade) + "\n                ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "w-2/12 p-3 truncate hidden md:table-cell"
    }, [(course.school_site) ? _c('div', [_vm._v("\n                " + _vm._s(course.school_site) + "\n              ")]) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "w-1/12 p-3 truncate"
    }, [(course.course_created) ? _c('div', {
      staticClass: "flex justify-center text-green-600"
    }, [_c('i', {
      staticClass: "fa-solid fa-check text-base leading-4"
    })]) : _c('div', {
      staticClass: "flex justify-center text-red-600"
    }, [_c('i', {
      staticClass: "fa fa-times text-base leading-4",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)], 1) : _c('div', {
    staticClass: "flex flex-col items-center justify-center text-base h-full"
  }, [_c('div', {
    staticClass: "mb-5"
  }, [_c('p', [_vm._v("\n            You have successfully connected your\n            " + _vm._s(_vm.integration.provider_name) + " account to Parlay. You can now\n            create new Parlay courses directly from your\n            " + _vm._s(_vm.integration.provider_name) + " account and connect existing\n            Parlay courses to existing\n            " + _vm._s(_vm.integration.provider_name) + " courses.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            It make a couple of minutes for your\n            " + _vm._s(_vm.integration.provider_name) + " courses to appear.\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-primary text-white font-semibold px-8 py-2 rounded",
    on: {
      "click": _vm.goToMyCourses
    }
  }, [_vm._v("\n          GO TO MY COURSES\n        ")])])])]), _vm._v(" "), (_vm.courses.length) ? _c('footer', {
    staticClass: "flex items-center justify-center my-5"
  }, [_c('button', {
    staticClass: "bg-primary text-white font-semibold px-8 py-2 rounded disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading || !_vm.selected_courses.length
    },
    on: {
      "click": _vm.createCourses
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', [_vm._v("CREATE AND ROSTER COURSES")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader"
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-adedf97e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/coursesToImportModal.vue
// module id = 1624
// module chunks = 61